import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 27 — HubSpot architecture / API / webhook / reporting service links.
 *
 * 11 of 12 Batch 27 posts are HubSpot platform topics → /hubspot-revops-architect.
 * The 12th (how-to-make-your-business-remote-ready-for-immediate-hiring) is a
 * hiring/operations topic → homepage contextual link via HIRING_TOPIC_SLUGS.
 *
 * See INTERNAL_LINKING_GUIDE.md + CONTENT_OPTIMIZATION_GUIDE.md.
 */
export const BATCH27_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "custom-webhook-handling-for-hubspot-crm": {
    url: "/hubspot-revops-architect",
    anchor: /custom webhook handling for HubSpot CRM/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-expert-to-pass-custom-data-to-hubspot-webhook": {
    url: "/hubspot-revops-architect",
    anchor: /pass custom data to a HubSpot webhook/i,
    label: "hire a HubSpot RevOps architect",
  },
  "integrate-proprietary-software-with-hubspot-api": {
    url: "/hubspot-revops-architect",
    anchor: /integrate proprietary software with the HubSpot API/i,
    label: "hire a HubSpot RevOps architect",
  },
  "fix-broken-zapier-hubspot-integrations": {
    url: "/hubspot-revops-architect",
    anchor: /fix broken Zapier HubSpot integrations/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-developer-freelance-custom-modules": {
    url: "/hubspot-revops-architect",
    anchor: /freelance HubSpot developer builds custom modules/i,
    label: "hire a HubSpot RevOps architect",
  },
  "real-time-data-syncing-hubspot-custom-endpoints": {
    url: "/hubspot-revops-architect",
    anchor: /real-time data syncing through HubSpot custom endpoints/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-error-handling-and-fallback-workflows": {
    url: "/hubspot-revops-architect",
    anchor: /error handling and fallback workflows in HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
  "lead-to-cash-pipeline-automation-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /lead-to-cash pipeline automation in HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-reporting-dashboard-creation-expert": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot reporting dashboard creation expert/i,
    label: "hire a HubSpot RevOps architect",
  },
  "how-to-track-custom-conversion-funnel-in-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /track a custom conversion funnel in HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
  "meta-conversion-api-integration-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /Meta Conversions API with HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
};
